<template>
  <div class="NavegacaoRegistros">
    <div class="NavegacaoRegistros_header mt-3">
      <h3 class="NavegacaoRegistros_title">
        Navegar entre registros
      </h3>
    </div>
    <div class="NavegacaoRegistros_body d-inline-flex mb-2">
      <button class="btn-navegacao"
              @click="navegar('first')">
        <IconSvg class="icon--sm icon_setas"
                 icon="duplaEsquerda" />
      </button>
      <button class="btn-navegacao"
              @click="navegar('previous')">
        <IconSvg class="icon--sm icon_setas"
                 icon="esquerda" />
      </button>

      <button class="btn-navegacao"
              @click="navegar('next')">
        <IconSvg class="icon--sm icon_setas"
                 icon="direita" />
      </button>
      <button class="btn-navegacao"
              @click="navegar('last')">
        <IconSvg class="icon--sm icon_setas"
                 icon="duplaDireita" />
      </button>
    </div>
    <h3 class="NavegacaoRegistros_title mb-1">
      Número do termo
    </h3>
    <div class="NavegacaoRegistros_body d-inline-flex">
      <input v-model="termo"
             name="registroId"
             class="form-control form-control-sm col-8"
             placeholder="000000"
             type="number"
             @keyup.enter="navegarByNumRegistro(termo)">
    </div>
  </div>
</template>
<script>
  /* services */
  import RegistrosService from "@/services/Registros"

  export default {
    name: 'NavegacaoRegistros',
    props: {
      propTipoRegistro: {type: String, default: null},
      propRegistroId: {type: Number, default: null}
    },
    data () {
      return {
        termo: null
      }
    },
    methods: {
      async navegar (operador) {
        try {
          loader({active: true, text: 'Carregando...'})

          const res = await RegistrosService.recordNavigation(this.propRegistroId, this.propTipoRegistro, operador)

          this.navigationRouter(res)

        } catch (error) {
          this.displayError('Erro!', 'Tente novamente ou contacte o suporte')
        } finally {
          loader({active: false, text: ''})
        }
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
      async navegarByNumRegistro (termo) {
        if (termo != null) {
          try {
            loader({active: true, text: 'Carregando...'})

            const res = await RegistrosService.getRegistroByTermo(termo, this.propTipoRegistro)

            this.navigationRouter(res)

          } catch (error) {
            this.displayError('Erro!', 'Tente novamente ou contacte o suporte')
          } finally {
            loader({active: false, text: ''})
          }
        }

      },
      async navigationRouter (res) {
        switch (this.propTipoRegistro) {
        case 'O':
        case 'NT':
          this.$router.push({name: 'resumo_obito', params: { id: res.obito_id, propObito: res }})
          break
        case 'N':
          this.$router.push({name: 'resumo_nascimento', params: { id: res.nascimento_id, propNascimento: res }})
          break
        case 'C':
        case 'CR':
          this.$router.push({name: 'resumo_casamento', params: { id: res.casamento_id, propCasamento: res }})
          break
        case 'D':
          this.$router.push({name: 'resumo_habilitacao_casamento', params: { id: res.habilitacao_casamento_id, propHabilitacao: res }})
          break
        }
      }
    }
  }
</script>
<style lang="scss">
  .NavegacaoRegistros {
    &_title {
      font-family: Roboto;
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.36;
      letter-spacing: normal;
      color: #ffffff;
    }
  }

  .btn-navegacao {
    width: 35px;
    height: 30px;
    margin: 5px 5px 0 0;
    border-radius: 4px;
    border: solid 1px #086aae;
    background-color: #ffffff;
    color: #074f7f;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: -2px;
  }

  .btn-navegacao:hover {
    color: #074f7f;
  }

  .btn-navegacao:focus {
    outline: 0px;
  }
  .btn-search-navegacao {
    border-radius: 4px;
    border: solid 1px #086aae;
    background-color: #ffffff;
    color: #074f7f;
    font-weight: 500;
    font-size: 15px;
    margin-left: 15px;
  }

  .icon {
    &_setas {
      width: 15px;
      stroke:  #074f7f;
      stroke-width: 1px;
    }
  }
</style>
